export const environment = {
  production: true,
  appTitle: 'ADDboard'
};
